

<template>
  <div class="container" style="margin-top: 42px;">
    <el-row class="faq-container" style="padding:0 110px 48px 0;">
      <el-col v-for="(faq, index) in faqs" :key="index" :span="12">
        <div class="faq-item" @click="handleClick(faq)">
          <h3 class="show-ellipsis">{{ faq.question }}</h3>
            <div class="faq-answer show-ellipsis">
               <i>答</i> A: {{ faq.answer }}
            </div>
        </div>
      </el-col>
    </el-row>
  </div>

</template>
<script>

export default {
props:{
  activeName:{
    type:String
  }
},
components: {

},
created() {
 
},
data() {
  return {
    faqs: [
    {
      id:'1',
      question: '【转运】我们是亚马逊的VE供货商，仓库能不能接受亚马逊到仓提货呢？',
      answer: '可以，目前美国两个仓库都可以接受VE自提。'
    },
    {
      id:'2',
      question: '【转运】亚马逊分配FBA地址大多在美国中东部地区，从美西的仓库发过去距离太远，运费太高，有没有解决方案？',
      answer: '我司一直都在跟进市场的走向和亚马逊的分仓情况，这个问题我们也留意到了，所以今年我们新增了美东的中转仓服务，美西美东两个中转仓同时运转，方便各卖家根据自身货物分仓情况自主选择，更贴心的服务，真正做到帮卖家节省物流成本。'
    },
    {
      id:'3',
      question: '【转运】整柜运输的时候，能不能不打托盘？',
      answer: '可以，但是不打托盘卸货比较麻烦，仓库需要耗费一定的人工。仓库需要耗费更多人工成本，相对的卸货费会增加。'
    },
    {
      id:'4',
      question: '【美国专线】网站显示签收后，但是一直没上架？',
      answer: '我司专线派送是按UPS官网显示签收为准，如果派送后长时间没有上架信息，我司会提供POD给客户，以此找亚马逊开CASE查询。'
    },
    {
      id:'5',
      question: '【国际快递】货物在签收后发现破损了怎么办？',
      answer: '如签收后有异常的，需在签收后7天内向当地服务商提出异常反馈并拿到当地受理备案号码，提交调查所需的资料，以便调查。破损件：提交当地受理备案号并提交:产品内包装，外包装图片，产品破损细节图，破损数量，重量，申报价值等调查所需资料，等候调查结果。'
    },
    {
      id:'6',
      question: '【报价】如何才能一次性报出准确优惠的价格？',
      answer: '尽量一次性给出完整的货物信息，包括：整票货物的品名、体积、重量、件数、最终派送地址等。货物信息越详尽，报价越快越准。'
    },
    // 其他的FAQ对象...
  ]
  };
},
methods: {
  handleClick(item){
      console.log(item,this.activeName,'item,activeName')
      this.$router.push({
        path:'/questionDetail',
        query:{
          id:item.id,
          activeName:this.activeName
        }
      })
    }
}

};
</script>
<style src="../index.css" scoped>


</style>